module.exports = __webpack_public_path__ + "img/palette2.c4d0f770.svg";